"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("../providers/AuthProvider");
const LoadingSpinner_1 = require("../components/LoadingSpinner");
/**
 * ProtectedRoutes component that redirects unauthenticated users to login,
 * preserving the intended destination URL
 * @returns {React.FC} The ProtectedRoutes component
 */
const ProtectedRoutes = () => {
    const { isAuthenticated, loading } = (0, AuthProvider_1.useAuth)();
    const location = (0, react_router_dom_1.useLocation)();
    // Show loading state while checking authentication
    if (loading) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.LoadingSpinner, { overlay: true, label: "Checking authentication..." });
    }
    // Redirect to login if not authenticated, preserving intended destination
    if (!isAuthenticated) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    // Render child routes if authenticated
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {});
};
exports.default = ProtectedRoutes;
